import dayjs from "dayjs";
import { map } from "lodash";
import { Button, Space, Table } from "antd";
import { ColumnType } from "antd/es/table";
import useModal from "antd/es/modal/useModal";

import { usePagination } from "../../hooks/usePagintation";
import { AuditForm } from "./AuditForm";
import { useAudits, useUpdateAudit } from "../../hooks/apis/audit";

type AuditListProps = {
  cars: Array<{
    bookingTimes: number[];
    id: number;
    title: string;
    imageUrl: { isCover: boolean; url: string }[];
    brand: { id: number; name: string };
    modal: string;
    price: number;
    type: string;
    years: number;
    coordinatorName?: string;
    createdAt: number;
    location?: string;
    merchantId: number;
    name: string;
    phone: string;
    salerId?: string;
    status: "PENDING" | "CONCATED" | "DONE";
    viewingType: "ONLINE" | "OFFLINE";

    color: string;
    basePrice: number;
    customerName: string;
    customerEmail: string;
    customerPhone: string;
    travelLicenseImageUrl: string;
    appraisalImageUrl?: string;
  }>;
};

export function AuditList() {
  const pagination = usePagination({
    defaultPageSize: 30,
  });

  const { data: { cars = [], total } = {}, isLoading: isAuditsLoading } = useAudits({
    take: pagination.take,
    skip: pagination.skip,
    reviewStatus: "REVIEWING",
  });

  const { mutateAsync: updateAuditDetail, isLoading: isUpdateAuditDetailLoading } = useUpdateAudit();

  const [modal, contextHolder] = useModal();

  const onEditButtonClick = async (car: AuditListProps["cars"][number]) => {
    modal.confirm({
      // width: 800,
      cancelText: "關閉",
      content: (
        <AuditForm
          car={{
            ...car,
            brand: car.brand.name,
            imageUrl: map(car.imageUrl || [], (item, index: number) => ({ ...item, id: index + 1 })) || [],
            bookingTimes: map(car.bookingTimes, item => dayjs(item)),
          }}
        />
      ),
      icon: null,
      okText: "通過",
      okButtonProps: { danger: true },
      title: "審核商品",
      onOk: async () => {
        return updateAuditDetail({ customerCarIds: [car.id] });
      },
    });
  };

  const columns: ColumnType<AuditListProps["cars"][number]>[] = [
    { align: "center", dataIndex: "id", title: "ID", width: 50 },
    {
      align: "left",
      dataIndex: "customerName",
      title: "賣家姓名",
      width: 60,
      render: (value: AuditListProps["cars"][number]["customerName"]) => <span>{value}</span>,
    },
    {
      align: "left",
      title: "賣家聯絡方式",
      width: 150,
      render: (_, row: AuditListProps["cars"][number]) => (
        <span>
          {row.customerEmail}
          <br />
          {row.customerPhone}
        </span>
      ),
    },
    {
      dataIndex: "title",
      title: "商品名稱",
      width: 200,
    },
    {
      title: "操作",
      width: 50,
      render: car => {
        return (
          <Button onClick={() => onEditButtonClick(car)} size="small" type="default">
            審核
          </Button>
        );
      },
    },
  ];

  return (
    <Space direction="vertical" className="w-full">
      <div className="text-2xl font-bold">審核管理</div>

      {contextHolder}

      <Table
        dataSource={cars || []}
        columns={columns}
        loading={isAuditsLoading || isUpdateAuditDetailLoading}
        pagination={{ ...pagination, total }}
        scroll={{ x: "max-content" }}
        size="small"
        rowKey="id"
      ></Table>
    </Space>
  );
}
